import axios from 'axios'
import Cookies from 'js-cookie';
import urlConfig from '../url'
const isMobile = () => {
    return !!navigator.userAgent.match(/AppleWebKit.*Mobile.*/) || !!navigator.userAgent.match(/Mobile/)
}

const dataPiont = (body) => {
    const params = {
        cmd: "com.crmpaas.apps.marketing_sitelog_put",
        body: JSON.stringify(body)
    };
    const encodedParams = new URLSearchParams(params).toString();
    axios.get(`${urlConfig.dataPiontUrl}?${encodedParams}`).then(res=>{
        
    }).catch(err=>{
        console.log(err,'数据上报失败')
    })
}


const searchParam = (str) => {
    const url = window.location.href
    if (url.indexOf(str) !== -1) {
        const reg = new RegExp("(^|&)" + str + "=([^&]*)(&|$)")
        const r = url.substr(url.indexOf('?') + 1).match(reg)
        if (r != null) {
            return r[2]
        }
    } else {
        return Cookies.get(str)
    }
}

const getCurrentFormattedTime =() => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并补零
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export default {
    isMobile,
    dataPiont,
    searchParam,
    getCurrentFormattedTime
}
